import { Col, Row } from "antd";
import React from "react";
import styled from "styled-components";
import { theme } from "../../../theme";
import { PaddingContent } from "../Layout/index.styled";

export interface DynamicRoutingProps {
  smallMenu?: string;
  menu?: string;
  navTarget?: string;
  defaultQuery?: string;
}

const SinglePageLayout: React.FC<DynamicRoutingProps> = (props) => {
  const { smallMenu = "", menu = "", children } = props;

  return (
    <PaddingContent>
      <Row>
        {menu && (
          <Col span={24} style={{ marginBottom: "4px" }}>
            <StyledMenu>{menu}</StyledMenu>
          </Col>
        )}
        {smallMenu && (
          <Col span={24}>
            <StyledSmallMenu>{`${smallMenu}`}</StyledSmallMenu>
          </Col>
        )}
        <Col span={24} style={{ paddingTop: (menu && 16) || 0 }}>
          {children}
        </Col>
      </Row>
    </PaddingContent>
  );
};

const StyledMenu = styled.div`
  ${theme.typo.body.r16};
`;

const StyledSmallMenu = styled.div`
  ${theme.typo.title.t32};
`;

export default SinglePageLayout;
